import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { filter, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AppState } from "../app.state";
import * as schedulerActions from "./scheduler.action";

@Injectable()
export class SchedulerEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>
      ) {}

    addTask$ = createEffect(() => 
        this.actions$.pipe(
            ofType(schedulerActions.addTask),
            withLatestFrom(this.store.select('scheduler')),
            filter(([action, state ]) => !state.tasksRunning[action.taskType]),
            map(([actionData, schedulerState]) => {
                return schedulerActions.startRunnig({taskType: actionData.taskType});
            })
        )
    );

    addTasks$ = createEffect(() => 
        this.actions$.pipe(
            ofType(schedulerActions.addTasks),
            withLatestFrom(this.store.select('scheduler')),
            filter(([action, state ]) => !state.tasksRunning[action.taskType]),
            map(([actionData, schedulerState]) => {
                return schedulerActions.startRunnig({taskType: actionData.taskType});
            })
        )
    );

    startRunnig$ = createEffect(() => 
        this.actions$.pipe(
            ofType(schedulerActions.startRunnig),
            map((action) => {
                return schedulerActions.executeTask({taskType: action.taskType});
            })
        )
    );

    executeTask$ = createEffect(() => 
        this.actions$.pipe(
            ofType(schedulerActions.executeTask),
            withLatestFrom(this.store.select('scheduler')),
            switchMap(async ([action, state]) => {
                await state.tasks[action.taskType][0]();
                this.store.dispatch(schedulerActions.executeTaskFinished({taskType: action.taskType}));
            })
        ), {dispatch: false}
    );

    executeTaskFinished$ = createEffect(() => 
        this.actions$.pipe(
            ofType(schedulerActions.executeTaskFinished),
            withLatestFrom(this.store.select('scheduler')),
            map(([action, state]) => {
                if (state.tasks[action.taskType].length > 0) {
                    return schedulerActions.executeTask({taskType: action.taskType});
                } else {
                    return schedulerActions.stopRunnig({taskType: action.taskType});
                }
            })
        )
    );
}